var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Base64 } from 'js-base64';
import { JW3TContent } from './content';
let skew = 300; // seconds
export class JW3TVerifier {
    constructor(verifier) {
        this._sigVerifier = verifier;
    }
    verify(jw3t) {
        return __awaiter(this, void 0, void 0, function* () {
            let [b64_header, b64_payload, b64_signature, ...rest] = (jw3t === null || jw3t === void 0 ? void 0 : jw3t.split('.')) || [];
            if (rest.length !== 0) {
                throw new Error('invalid token. malformed');
            }
            if (!b64_header ||
                !b64_payload ||
                !b64_signature ||
                !Base64.isValid(b64_header) ||
                !Base64.isValid(b64_payload) ||
                !Base64.isValid(b64_signature)) {
                throw new Error('invalid token. header, payload or signature is missing');
            }
            let header = JSON.parse(Base64.decode(b64_header));
            let payload = JSON.parse(Base64.decode(b64_payload));
            let signature = Base64.toUint8Array(b64_signature);
            let { algorithm } = header || {};
            // validate nbf if exists
            let { address: address, not_before: notBefore, audience: audience, expires_at: expiration, } = payload;
            if (!expiration) {
                throw new Error('invalid token.  expiration claim is missing');
            }
            let nowEpoch = Math.floor(Date.now() / 1000);
            if (nowEpoch > expiration + skew) {
                throw new Error('invalid token.  token is expired');
            }
            if (notBefore && nowEpoch < notBefore - skew) {
                throw new Error('invalid token.  token is not valid before nbf time');
            }
            // validate address
            if (!address) {
                throw new Error('invalid token.  address claim is missing');
            }
            let content = JW3TContent.fromBase64Url(`${b64_header}.${b64_payload}`);
            let jsonStrContent = content.stringify();
            let sigIsValid = yield this._sigVerifier.verify(algorithm, jsonStrContent, signature, address);
            if (!sigIsValid) {
                throw new Error('invalid token, signiture is not valid');
            }
            return { header, payload };
        });
    }
}
